import React from 'react';
import styled from 'styled-components';
import BaseButton, { variables } from 'styled-up/dist/Button';
import Spinner from './Spinner';

variables.size.small.paddingH = 10;
variables.size.normal.paddingH = 15;
variables.size.large.paddingH = 20;

const StyledButton = styled(BaseButton)`
  border-color: transparent !important;

  span.children {
    ${props => props.working && 'color: transparent;'}
  }

  span.spinner {
    display: none;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    ${props => props.working && 'display: block;'}

    ${Spinner} {
      border-right-color: currentColor !important;
      border-top-color: currentColor !important;
    }
  }
`;

function Button({ children, size, working, ...rest }) {
  return (
    <StyledButton {...rest} size={size} working={working}>
      <span className="children">{children}</span>

      <span className="spinner">
        <Spinner size={size} />
      </span>
    </StyledButton>
  );
}

export { variables };

export default Button;
